

import EnquiryTable, { EnquiryData } from "./EnquiryTable";
import EnquiryCard from "./EnquiryCard";

interface EnquiryListProps {
  enquiries: EnquiryData[];
  isStaff: boolean;
  canDelete: boolean;
  onEdit: (enquiry: EnquiryData) => void;
  onConvert: (enquiry: EnquiryData) => void;
  onDelete: (id: number) => void;
  onViewDetails?: (id: number) => void;
}

export default function EnquiryList({
  enquiries,
  isStaff,
  canDelete,
  onEdit,
  onConvert,
  onDelete,
  onViewDetails,
}: EnquiryListProps) {
  return (
    <>
      {/* Desktop Table */}
      <EnquiryTable
        enquiries={enquiries}
        isStaff={isStaff}
        canDelete={canDelete}
        onEdit={onEdit}
        onConvert={onConvert}
        onDelete={onDelete}
        onViewDetails={onViewDetails}
      />
      
      {/* Mobile Cards */}
      <EnquiryCard
        enquiries={enquiries}
        isStaff={isStaff}
        canDelete={canDelete}
        onEdit={onEdit}
        onConvert={onConvert}
        onDelete={onDelete}
        onViewDetails={onViewDetails}
      />
    </>
  );
}
